<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  showHelpers: {
    type: Boolean,
    default: true,
  },
});

const iconClasses = {
  complete: 'i-lucide-check-circle-2 text-n-teal-11',
  blocker: 'i-lucide-circle-x text-n-ruby-11',
  warning: 'i-lucide-triangle-alert text-n-amber-11',
  pending: 'i-lucide-circle-dashed text-n-slate-10',
};

const statusClasses = {
  complete: 'bg-n-teal-3 text-n-teal-11',
  blocker: 'bg-n-ruby-3 text-n-ruby-11',
  warning: 'bg-n-amber-3 text-n-amber-11',
  pending: 'bg-n-alpha-2 text-n-slate-11',
};
</script>

<template>
  <div class="flex flex-col divide-y divide-n-weak">
    <article
      v-for="item in items"
      :key="item.label"
      class="flex items-start gap-3 py-3 first:pt-0 last:pb-0"
    >
      <span
        class="mt-0.5 size-4 shrink-0"
        :class="
          iconClasses[item.severity || (item.done ? 'complete' : 'pending')]
        "
        aria-hidden="true"
      />
      <div class="min-w-0">
        <div class="flex flex-wrap items-center gap-2">
          <p class="text-sm font-medium text-n-slate-12">
            {{ item.label }}
          </p>
          <span
            v-if="item.statusLabel"
            class="rounded-full px-2 py-0.5 text-xs font-medium"
            :class="
              statusClasses[
                item.severity || (item.done ? 'complete' : 'pending')
              ]
            "
          >
            {{ item.statusLabel }}
          </span>
        </div>
        <p
          v-if="showHelpers && item.helper"
          class="mt-1 text-xs leading-relaxed text-n-slate-10"
        >
          {{ item.helper }}
        </p>
      </div>
    </article>
  </div>
</template>
